import { Component, input } from '@angular/core';
import { TranslatePipe } from '../../../core/i18n';

/**
 * Success banner shown when a shipper arrives with an active coupon code.
 * Matches Figma node 17744:18192 (green #daeebe background, 16px padding, 8px radius).
 */
@Component({
  selector: 'app-shell-coupon-banner',
  imports: [TranslatePipe],
  templateUrl: './shell-coupon-banner.html',
  styleUrl: './shell-coupon-banner.scss',
})
export class ShellCouponBanner {
  readonly visible = input.required<boolean>();
}
